export default __webpack_public_path__ + "static/media/twitter-icon.ab65307a.svg";